// extracted by mini-css-extract-plugin
export default {"modalDiv":"Modal_modalDiv__U1y4m","hystmodal":"Modal_hystmodal__8RZZZ"};